import { RootState } from "@/redux/store";
import { useSelector } from "react-redux";

const useStep3 = () => {
  const communityData = useSelector(
    (state: RootState) => state.currentData.communityData
  );
  const bulkUploadDtl = useSelector(
    (state: RootState) => state.currentData.bulkUploadDtl
  );
  
  return {
    bulkUploadDtl: bulkUploadDtl?.commitData,
    communityData
  }
}

export default useStep3;